/**
 * ListTrac uses a lightweight JavaScript library that includes methods to track events Brokers are
 * keen to capture. The events actively monitored by ListTrac typically occur within a single HTML page
 * on your site where the detailed information related to a broker's listing is presented - the 'Listing
 * Detail' page.
 *
 * The following activity are tracked:
 *   -  Listing Viewed
 *   -  Lead Generated
 *   -  Listing Shared
 *   -  Tagged as Favorite
 *   -  Virtual Tour Viewed
 *   -  Image Gallery Viewed
 *   -  Click Through
 *   -  Print Listing
 *   -  Agent Profile Viewed
 *
 */
define(['jquery'], function ($) {
   "use strict";

   function doEventWithParams(type, mlsId, zipcode, sourceId, brand, listingId, agentId) {
      if(type) {
         sendEvent(type, mlsId, zipcode, sourceId, brand, listingId, agentId);
      }
   }

   function doEvent(type, jContainer) {
      if(jContainer && type) {
         sendEvent(type, jContainer.data('mls'), jContainer.data('zipcode'), jContainer.data('source-id'), jContainer.data('brand-cd'), jContainer.data('listing-id'), "");
      }
   }

   function sendEvent(type, mlsId, zipcode, sourceId, brand, listingId, agentId) {
      var orgId = "CEN",
         loggedInAgentId = "",
         report = "",
         id = "";

      window.__onListTracLoaded(function() {

         if(agentId != null && agentId != '') {
            agentId = "agentID_" + agentId;
         }

         if(mlsId != null && mlsId != "" && mlsId != "N/A") {
            id = mlsId;
         } else if(listingId != null && listingId != "") {
            id = listingId;
         } else {
            // ListTrac does not support listing GUID.
            //id = sourceId;
         }

         if(type && id) {
            _LT._trackEvent(_eventType[type], id, zipcode, agentId, loggedInAgentId, report, orgId);
         }
      });
   }

   var self = {
      doEvent : doEvent,
      doEventWithParams: doEventWithParams
   };

   // For anchors with inline JS only
   window.listTrac = self;

   return self;
});
